import { createReducer, on } from '@ngrx/store';
import { MdmAppleDevicesApiActions, MdmAppleProfilesEffectsActions } from './apple-profiles.actions';
import { initialState, adapter } from './apple-profiles.state';

export const appleProfilesReducer = createReducer(
  initialState,
  on(MdmAppleDevicesApiActions.profilesLoaded, (state, { profiles }) => adapter.upsertMany(profiles, state)),
  on(MdmAppleProfilesEffectsActions.profileAdded, (state, { profile }) => adapter.upsertOne(profile, state)),
  on(MdmAppleProfilesEffectsActions.profileRemoved, (state, { udid, profileIdentifier }) =>
    adapter.removeOne(`${udid}-${profileIdentifier}`, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectProfileIds = selectIds;

export const selectAppleProfileEntities = selectEntities;

export const selectAllProfiles = selectAll;
